import API from "../../services/api";

export async function fetchOnboardingProgress() {
  const res = await API.get("/setup/onboarding/progress");
  return res.data;
}

export async function skipOnboardingStep(step) {
  const res = await API.post(`/setup/onboarding/skip/${step}`);
  return res.data;
}

export async function resetOnboarding() {
  const res = await API.delete("/setup/onboarding/reset");
  return res.data;
}
